<script>
  import ImageLoader from "svelte-lazy-image-loader";
  import { hexToRgb } from "../helpers/utilities";
  import ProjectDetails from "../components/content/ProjectDetails.svelte";

  export let url;
  export let alt = "";
  export let title = "";
  export let lazy = false;
  export let project;

  let maskColor1 = hexToRgb("#032539");
  let showDetails = false;

  let src = url;
  let observer = null;

  if (lazy) {
    src = "";
    observer = new IntersectionObserver(onIntersect, { rootMargin: "600px" });
  }

  function onIntersect(entries) {
    if (!src && entries[0].isIntersecting) {
      src = url;
    }
  }

  function lazyLoad(node) {
    observer && observer.observe(node);
    return {
      destroy() {
        observer && observer.unobserve(node);
      }
    };
  }
</script>

<style>
  article {
    position: relative;
  }
  .mask {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    background-image: var(--background-image);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .image-banner-container {
    text-align: center;
    color: var(--color-theme-4);
    background-color: var(--color-theme-5);
    opacity: 0.9;
    padding: 1rem 2rem;
  }
  .image-banner-label {
    text-transform: uppercase;
    font-weight: 900;
    margin: 0;
  }
  /* .details-link {
    margin-bottom: 0;
  } */
</style>

<article use:lazyLoad>
  <div
    class="mask"
    style="--background-image: linear-gradient(to top, rgba(0,0,0, 0.75) 0%,
    rgba(0, 0, 0, 0.2) 100%)">
    <div class="image-banner-container">
      <h4 class="image-banner-label">{title}</h4>
      <!-- {#if project.screenshots.length > 0}
        <p class="details-link">
          <a href="#!" on:click|preventDefault={() => (showDetails = true)}>
            Screens
          </a>
        </p>
      {/if} -->
    </div>
  </div>
  <img {src} {alt} />
</article>

{#if showDetails}
  <ProjectDetails on:close={() => (showDetails = false)} {project} />
{/if}
